require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/fn/object/assign.js
// module id = 565
// module chunks = 0